import $ from "jquery";
import NavView from "../common/views/NavView";
import OverlayView from "../common/views/OverlayView";
import "../../../Assets/javascripts/nav/others/jquery.comboToList.js";
import { MagnificPopup } from "../../../Assets/javascripts/common/dynamic-imports/MagnificPopup";
import "component?js-PartialAsync"
import "component?js-AccountExpand"
import "component?js-OrdersExpand"
import "component?js-Accordion"
import "component?js-NewslettersFilters"
import "component?js-NewslettersPreferences"
import "component?js-OrderStatusPopup"
import "component?js-Order"
import "component?js-PopupCreditPopup"
import "component?js-login-toggle"
import "component?js-PopupInline"
import "component?js-Overlay"
import SymbolTemplate from "../../templates/Symbol.mustache";
import {symbolsURL} from "../common/others/Configuration";


  new NavView({ el: $('body') });

  // Scroll to Last Order
  var latestOrder = $(".ma-Order--latest");
  if (latestOrder.length) {
    $("body").animate({
      scrollTop: $order.offset().top - headerHeight
    }, 'slow');
  }

  // Radio input click on label in payment regularization
  $(".js-MaRegulRadioWrap input").each(function () {
    var idRegulRadioWrapInput = $(this).attr("id");
    $(this).next().attr("for", idRegulRadioWrapInput);
  });

  // dateRange
  $(".js-OrderFilter-dateRange").comboToList({
    onChange: function () {
      var dateRange = $(this).attr("data-value");
      var orderType = $(".js-OrderFilter-orderType").attr("data-value");
      var $form = $("#formSearchOrderId");

      $form.submit();
    }
  });

  // ordertype
  $(".js-OrderFilter-orderType").comboToList({
    onChange: function () {
      var dateRange = $(".js-OrderFilter-dateRange").attr("data-value");
      var orderType = $(this).attr("data-value");
      var $form = $("#formSearchOrderId");

      $form.submit();
    }
  });

  // Incident AJAX form submit
  $(document).on('click', '.js-IncidentFormBtn', function (e) {
    e.preventDefault();

    var $form = $(".js-IncidentFormAjax").eq(0);
    var $target = $('#incidentContent');

    $target.empty().append(SymbolTemplate.render({ClassName: "incidentContent__loader", SymbolsUrl: symbolsURL, SymbolName: "icon_i_290_loader"}));

    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      success: function (data) {
        $target.html(data);

        // Move MVC validation input[hidden]
        var $checks = $('.js-IncidentToggleQty');

        if ($checks.length) {
          var i, iMax = $checks.length;

          for (i = 0; i < iMax; i++) {
            var $check = $checks.eq(i);
            var $checkWrapper = $check.parent();
            $checkWrapper.append($checkWrapper.children('input[type=hidden]'));
          }
        }

      },
      error: function () {
        $target.html('Une erreur est survenue, merci de bien vouloir réessayer plus tard.');
      }
    });
  });

  // Membership card popin
  document.addEventListener("click", e => {
    if (e.target && e.target.closest(".js-CardPopin")) {
      new MagnificPopup(e.target.closest(".js-CardPopin"), { noBind: true }).open({
        closeOnContentClick: true,
        fixedContentPos: true,
        mainClass: "ma-CardPopin",
        overflowY: "hidden",
        type: "inline",
        callbacks: {
          open: function () {
            $("html").addClass("ma-CardPopin-orientation");
            //window.screen.lockOrientation("landscape");
          },
          close: function () {
            $("html").removeClass("ma-CardPopin-orientation");
            //window.screen.unlockOrientation();
          }
        }
      });
    }
  });

  // Display/hide select for quantity
  $(document).on('change', '.js-IncidentToggleQty', function () {
    var $contentCombo = $(this).parent().next('.form-inline');

    $contentCombo.toggleClass("invisible");

    if ($contentCombo.children().prop("disabled")) {
      $contentCombo.children().prop("disabled", "");
      $("option[value=1]", $contentCombo.children()).prop("selected", "selected");
    } else {
      $contentCombo.children().prop("disabled", "disabled");
    }
  });

  // Flip card
  $(document).on("click", ".js-FlipCard", function () {
    // data-flipcard : css class to toggle with css modifier --flip
    var flipItem = $(this).data("flipcard");

    $(this).parent().find("." + flipItem).toggleClass(flipItem + "--flip");
    $(this).find('.js-FlipCard-icon').toggleClass('hidden');
  });
